'use strict';

DoohApps
.factory('MediaAssetHelper', ['$filter', 'DialogHandler',
    function ($filter, DialogHandler) {

        return {
            SelectImage: function (scope, file) {
                scope.mediaSelected = true;
                if (file.MediaAssetID != undefined) {

                    for (var i = 0; i < scope.application.AttchedAssetFiles.length; i++) {
                        if (file.FileURL == scope.application.AttchedAssetFiles[i].FileURL) {
                            if (scope.application.AttchedAssetFiles[i].isDefault)
                                scope.showBigger.isActive = true;
                            else scope.showBigger.isActive = false;
                        }
                    }


                    scope.showBigger.FileUrl = file.FileURL;
                    scope.showBigger.MediaAssetID = file.MediaAssetID;
                    scope.showBigger.IconUrl = file.IconUrl;
                }
                else {
                    scope.showBigger.FileUrl = file.FileURL;
                }
            },
            RemoveSelected: function (scope) { // whay are there 2 lists? 

                for (var i = 0; i < scope.application.AttchedAssetFiles.length; i++) {
                    if (scope.showBigger.MediaAssetID == scope.application.AttchedAssetFiles[i].MediaAssetID) {

                        if (scope.application.AttchedAssetFiles[i].isDefault && scope.application.AttchedAssetFiles.length > 1) {
                            scope.application.AttchedAssetFiles[i == 0 ? 1 : 0].isDefault = true;
                            scope.defaultThumbnail.FileUrl = scope.application.AttchedAssetFiles[i == 0 ? 1 : 0].FileUrl;
                        } else {
                            delete scope.defaultThumbnail.FileUrl;
                        }

                        scope.showBigger.FileUrl = null;
                        scope.showBigger.MediaAssetID = undefined;
                        scope.showBigger.IconUrl = null;
                        scope.showBigger.isActive = false;
                        scope.application.AttchedAssetFiles.splice(i, 1);
                        break;
                    }
                }

            },
            SetAsDefault: function (scope) {
                for (var i = 0; i < scope.application.AttchedAssetFiles.length; i++) {
                    if (scope.showBigger.FileUrl == scope.application.AttchedAssetFiles[i].FileURL) {
                        scope.application.AttchedAssetFiles[i].isDefault = true;
                        scope.showBigger.isActive = true;
                    }
                    else {
                        scope.application.AttchedAssetFiles[i].isDefault = false;
                    }
                }
            },
            SaveAppImages: function (scope, bll) {
                if (!scope.noChangeAllowed) {
                    scope.reqSave = true;
                    var defaultThumbnail = {};

                    if (scope.application.AttchedAssetFiles != null) {
                        for (var i = 0; i < scope.application.AttchedAssetFiles.length; i++) {
                            if (scope.application.AttchedAssetFiles[i].isDefault) {
                                defaultThumbnail.FileUrl = scope.application.AttchedAssetFiles[i].FileURL;
                                defaultThumbnail.IconUrl = scope.application.AttchedAssetFiles[i].IconUrl;
                            }
                        }
                    }

                    if (typeof (defaultThumbnail.FileUrl) === 'undefined' && scope.application.AttchedAssetFiles != null) {
                        DialogHandler.AddError('Default Image not selected!');
                        scope.reqSave = false;
                        return;
                    }

                    var ImageObject = {};
                    ImageObject.MainScreenURL = defaultThumbnail.FileUrl;
                    ImageObject.IconURL = defaultThumbnail.IconUrl;

                    if (scope.application.AttchedAssetFiles == null && scope.newMediaList.length == 0) {
                        ImageObject.MainScreenURL = null;
                        ImageObject.IconURL = null;
                    }

                    ImageObject.ApplicationID = scope.application.ApplicationID;
                    ImageObject.VersionID = scope.application.ApplicationVersionID;
                    ImageObject.MediaAssetIdList = [];

                    if (scope.application.AttchedAssetFiles != null) {
                        scope.application.AttchedAssetFiles.forEach(function (file) {
                            ImageObject.MediaAssetIdList.push(file.MediaAssetID);
                        });
                    }

                    bll.updateAppImages(function (data) {
                        scope.reqSave = false;
                        if (data.hasError) {
                            DialogHandler.AddError(data.error);
                        } else {
                            DialogHandler.AddMessage('Changes saved!');
                            if (scope.EditableShowBigger.FileUrl != scope.showBigger.FileUrl || scope.newMediaList.length > 0 || scope.removeMediaList.length > 0) {
                                scope.EditableShowBigger.FileUrl = angular.copy(scope.showBigger.FileUrl);
                            }
                            scope.ReloadVersion();
                        }

                    }, ImageObject);
                }
            }
        }
    }]);